<config-login-settings [RBACORG]="RBACORG" [PERMISSION]="PERMISSION" [configureEvent]="configureEvent$"></config-login-settings>
